/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Spinner } from 'react-bootstrap';

import {
  fetchData,
  selectWeatherStationId,
  selectStartDate,
  selectEndDate,
  selectStatus,
} from '@stores/dataVisualizationSlice';
import { currentGraphView, currentGraphViewId, addGraphByPosition } from '@stores/graphViewPageSlice';

import { STATE_STATUS } from '@awp/constants';
import GraphContainer from '@graphs/SingleStation/Container';

const getGraphList = (wsId, graphView) => {
  if (!wsId || !graphView || Number.isNaN(wsId)) return [];
  //parse the structure from the graph view, note it's in string format
  const graphs = graphView.DataGraphs || [];

  return graphs.map((e) => {
    return { ...e, weatherStationId: wsId };
  });
};

let overlayStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

let spinnerStyle = {
  position: 'fixed',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 1001,
};

const GraphViewRenderer = () => {
  const graphView = useSelector(currentGraphView);
  const graphViewId = useSelector(currentGraphViewId);

  const status = useSelector(selectStatus);
  const weatherStationId = useSelector(selectWeatherStationId);
  const startDate = useSelector(selectStartDate);
  const endDate = useSelector(selectEndDate);

  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (weatherStationId == null) return;
    if (startDate.error !== '' || endDate.error !== '') {
      //if (endDate.error !== '') {
      return;
    }

    //setLoading(true);
    dispatch(fetchData());
  }, [weatherStationId, endDate, startDate]);

  useEffect(() => {
    // true when loading
    setLoading(status.data === STATE_STATUS.LOADING || status.additionalData === STATE_STATUS.LOADING);
  }, [status]);

  const createGraph = () => {
    dispatch(addGraphByPosition({ graphId: -1, viewAction: 'addBottom' }));
  };

  return (
    <>
      {getGraphList(weatherStationId, graphView).map((graph) => {
        const id = graph.DataGraphId + '_' + weatherStationId;

        return <GraphContainer id={id} key={id} />;
      })}
      {loading && (
        <>
          <div style={overlayStyle}></div>
          <div>
            <div className="text-center mt-4" style={spinnerStyle}>
              <p>Loading Data...</p>
              <Spinner animation="border" />
            </div>
          </div>
        </>
      )}
      {!loading && graphViewId ? (
        <div className="graph__add">
          <button type="button" className="btn btn-primary" onClick={() => createGraph()}>
            Add Graph
          </button>
        </div>
      ) : (
        <span></span>
      )}
    </>
  );
};

export default GraphViewRenderer;
